import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { forwardRef } from 'react'
import SvgClose from '#/assets/images/icons/close.svg'
import Button from '#/components/Button'
import Modal from '#/components/Modal'
import cn from '#/utils/classnames'

type Props = {
  children?: React.ReactNode
  visible: boolean
  title?: string
  noPadding?: boolean
  whiteBackground?: boolean
  onClose: () => void
  subViewType?: string | boolean
  isMobile: boolean
}

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) => <Slide ref={ref} direction='right' {...props} />)

const DetailView: React.FC<Props> = ({
  children,
  noPadding,
  visible,
  title,
  onClose,
  subViewType,
  whiteBackground,
  isMobile
}) => {
  const classBySubView = () => {
    if (subViewType === 'Valuation' || subViewType === 'RentalValuation') {
      return 'w-full h-full sm:w-3/4 sm:h-auto'
    } else if (subViewType === 'StreetView') {
      return 'w-full h-full sm:w-3/4 sm:h-3/4;'
    } else if (subViewType === 'TaxInformation') {
      return 'xs:w-[500px] bg-primary-bg'
    } else if (subViewType === 'MarketTrends') {
      return 'xs:w-[500px]'
    } else {
      return 'xs:w-auto'
    }
  }

  return (
    <Modal
      TransitionComponent={isMobile ? Transition : undefined}
      className={cn(
        'bg-gray-50 p-0 !m-0 !rounded-none !max-h-full w-full h-full',
        'xs:!rounded-xl xs:h-auto xs:!max-h-[84%]',
        'sm:!max-w-screen-sm md:!max-w-screen-md',
        classBySubView()
      )}
      closeButton={false}
      scroll='paper'
      visible={visible}
      onClose={onClose}
    >
      <div className='z-10 flex h-14 flex-none items-center justify-between bg-gray-100 px-2 shadow xs:px-4'>
        <span className='max-w-[400px] overflow-hidden overflow-ellipsis whitespace-nowrap font-semibold xs:text-xl'>{title}</span>
        <Button className='rounded-full p-1' onClick={onClose}>
          <SvgClose onClick={onClose} />
        </Button>
      </div>
      <div
        className={cn(
          'flex-1 overflow-y-auto ',
          { 'p-2 xs:p-4': !noPadding },
          { 'bg-white': whiteBackground }
        )}
      >
        {children}
      </div>
    </Modal>
  )
}

export default DetailView
